import React, { useMemo } from 'react';
import classNames from 'classnames';
import { ComponentConstructor } from '@splidejs/splide';
import {
  Options,
  Splide,
  SplideSlide,
  SplideTrack,
} from '@splidejs/react-splide';

import styles from './Slide.module.scss';

type PropsType<T> = {
  items: T[];
  renderItem: (item: T) => JSX.Element;
  loopKey: (item: T) => string;
  options?: Options;
  extensions?: Record<string, ComponentConstructor>;
  className?: string;
  classes?: ClassesType;
};

type ClassesType = {
  arrow?: string;
  nextArrow?: string;
  prevArrow?: string;
  slide?: string;
  track?: string;
};

const DEFAULT_PER_PAGE = 3;

// @TODO - Replace actual color slide by this component
export default function Slide<T>({
  items,
  renderItem,
  loopKey,
  options,
  extensions,
  className,
  classes,
}: PropsType<T>): JSX.Element {
  const slideOptions: Options = useMemo(() => {
    return {
      ...{
        pagination: false,
        updateOnMove: false,
        mediaQuery: 'min',
        perPage: DEFAULT_PER_PAGE,
        perMove: 1,
        classes: {
          arrow: classNames('splide__arrow', styles.arrow, classes?.arrow),
          next: classNames(
            'splide__arrow--next',
            styles.nextArrow,
            classes?.nextArrow
          ),
          prev: classNames(
            'splide__arrow--prev',
            styles.prevArrow,
            classes?.prevArrow
          ),
        },
      },
      ...options,
    };
  }, []);

  return (
    <Splide
      options={slideOptions}
      className={classNames(styles.container, className)}
      hasTrack={false}
      extensions={extensions}
    >
      <SplideTrack className={classNames(styles.track, classes?.track)}>
        {items.map(item => (
          <SplideSlide key={loopKey(item)} className={classes?.slide}>
            {renderItem(item)}
          </SplideSlide>
        ))}
      </SplideTrack>
    </Splide>
  );
}
